import React from "react";
import { getForm1099BoxFilterValueLabel } from "@common/constants/domains/accounting/form1099Box";
import { AccountingReportFilters } from "../types";

export const Form1099BoxFilterLabel: React.FC<{
    filters: AccountingReportFilters;
}> = ({ filters }) => {
    const labels = (filters.form1099Boxes ?? []).map(
        getForm1099BoxFilterValueLabel,
    );
    return <>{labels.join(", ")}</>;
};
